import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { nextBillionApiInterceptor } from './core/interceptors/nextbillion-api.interceptor';
import { idealPostcodesApiInterceptor } from './core/interceptors/ideal-postcodes-api.interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideNgxStripe } from 'ngx-stripe';
import { environment } from '../environments/environment';
import { tokenInterceptor } from './core/interceptors/token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Reset scroll to the top on each navigation (and restore on back/forward)
    // so a new step never inherits the previous page's scroll position.
    provideRouter(
      routes,
      // Restore scroll on back/forward, and scroll to #fragment targets (used by
      // the shared footer's "How it works" / "FAQs" links).
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        nextBillionApiInterceptor,
        idealPostcodesApiInterceptor,
        tokenInterceptor,
      ]),
    ),
    provideNativeDateAdapter(),
    provideNgxStripe(environment.stripe.publicKey),
  ],
};
